import { render, staticRenderFns } from "./RegisterIcon.vue?vue&type=template&id=7d0ac3d4&scoped=true"
import script from "./RegisterIcon.vue?vue&type=script&lang=js"
export * from "./RegisterIcon.vue?vue&type=script&lang=js"
import style0 from "./RegisterIcon.vue?vue&type=style&index=0&id=7d0ac3d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0ac3d4",
  null
  
)

export default component.exports